import WebServiceRequest from "../../Api/WebServiceRequest";

class UserReportGetAllRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/GetList");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default UserReportGetAllRequest;
